import { Record } from 'immutable';

import airtableIcon from '../../../assets/icons/20/airtable.svg';
import googleAdsIcon from '../../../assets/icons/20/google_ads.svg';
import hubspotIcon from '../../../assets/icons/20/hubspot.svg';
import linearIcon from '../../../assets/icons/20/linear.svg';
import linkedinIcon from '../../../assets/icons/20/linkedin.svg';
import quickbooksIcon from '../../../assets/icons/20/quickbooks.svg';
import salesforceIcon from '../../../assets/icons/20/salesforce.svg';
import stripeIcon from '../../../assets/icons/20/stripe.svg';
import productSchemaIcon from '../../../assets/icons/20/product_schema.svg';
import metricsSchemaIcon from '../../../assets/icons/20/metrics_schema.svg';

class Integration extends Record({
  id: null,
  allowsCustomAttributes: null,
  displayName: null,
  name: null,
  schema: null,
  isActive: null,
  picture: null,
  createdAt: null,
  createdBy: null,
  updatedAt: null,
  updatedBy: null,
  deletedAt: null,
  deletedBy: null
}) {
  get pictureUrl() {
    if (this.schema === 'product') {
      return productSchemaIcon;
    }

    if (this.schema === 'metrics') {
      return metricsSchemaIcon;
    }

    // match name using regex
    if (this.name.match(/airtable/i)) {
      return airtableIcon;
    }

    if (this.name.match(/google_ads/i)) {
      return googleAdsIcon;
    }

    if (this.name.match(/hubspot/i)) {
      return hubspotIcon;
    }

    if (this.name.match(/linear/i)) {
      return linearIcon;
    }

    if (this.name.match(/linkedin/i)) {
      return linkedinIcon;
    }

    if (this.name.match(/quickbooks/i)) {
      return quickbooksIcon;
    }

    if (this.name.match(/salesforce/i)) {
      return salesforceIcon;
    }

    if (this.name.match(/stripe/i)) {
      return stripeIcon;
    }

    return productSchemaIcon;
  }
}

export { Integration };
